"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-prompts.disabled': 'Advanced prompts feature is not available in your current plan.',
};
